import {mapState, mapGetters, mapActions} from 'vuex'
import Pluralize from 'pluralize'

export const pluralizeMethods ={
  pluralize(word, count){
    return Pluralize( word, count )
  }
}
export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser ? state.currentUser : {},
  }),
  ...mapGetters('auth', ['loggedIn', 'isDeAuthed']),
}
export const userMethods = {
  ...mapGetters('auth', ['getUserPermissions', 'getUserType', 'isXeroConnected']),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'outlookLogin', 'outlookAuthorize'])

// Country store
export const countriesComputed = {
  ...mapGetters('countries', ['listCountries', 'listStates']),
}

export const countriesMethods = mapActions('countries', ['getCountries', 'getStates', 'getListCountries'])

export const businessesMethods = mapActions('businesses', ['getBusiness', 'updateBusiness'])
export const sitesMethods = mapActions('sites', ['resolveSiteData'])
export const sitesComputed = {
  ...mapState('sites', {
    siteData: (state) => state.siteData ? state.siteData : null,
  }),
}

// Branch store
export const branchesComputed = {
  ...mapGetters('branches', ['listBranches', 'listDepartments', 'detailBranch']),
}

export const branchesMethods = mapActions('branches',
  ['getBranches', 'getListBranches', 'getDepartments', 'getListDepartments', 'createBranch', 'getBranch', 'updateBranch', 'exportBranchesCsv', 'toggleDataDetailsBranch', 'importBranch', 'downloadImportBranchesTemplate'])

// Staff store
export const staffsComputed = {
  ...mapGetters('staffs', ['listStaffs']),
}

export const staffsMethods = mapActions('staffs', ['getStaffs', 'getListStaffs', 'exportStaffsCsv', 'createStaff', 'updateStaff', 'getStaff', 'toggleStaffDataDetails', 'importStaff', 'downloadImportStaffTemplate'])

export const permissionsComputed = {
  ...mapGetters('permissions', ['listPermissions']),
}

export const permissionsMethods = mapActions('permissions', ['getPermissions'])

export const rolesComputed = {
  ...mapGetters('roles', ['listRoles', 'detailRole']),
}

export const rolesMethods = mapActions('roles', ['getRoles', 'getListRoles', 'getRole', 'createRole', 'updateRole', 'exportRolesCsv', 'toggleRoleDataDetails'])

export const contactRolesMethods = mapActions('contactRoles', ['getContactRoles'])

// Finances store
export const financesComputed = {
  ...mapGetters('finance', ['listFinances']),
}

export const financesMethods = mapActions('finance', ['getListFinances', 'getFinances', 'exportFinancesCsv', 'toggleDataDetails', 'createFinance', 'getFinance', 'updateFinance', 'deleteFinancier', 'importFinance', 'downloadImportFinancesTemplate', 'searchFinances'])

// Address Type store
export const addressTypesComputed = {
  ...mapGetters('addressTypes', ['listAddressTypes', 'listAddresses']),
}

export const addressTypesMethods = mapActions('addressTypes', ['getAddressType','getAddressTypes', 'getAddresses', 'getListAddressTypes', 'createAddressTypes', 'updateAddressTypes', 'deleteAddressTypes'])

// Supplier store
export const suppliersComputed = {
  ...mapGetters('suppliers', ['listSuppliers', 'detailSupplier']),
}

export const supplierMethods = mapActions('suppliers', ['getSuppliers', 'getListSuppliers', 'exportSuppliersCsv', 'createSupplier', 'getSupplier',
  'updateSupplier', 'deleteSupplier', 'toggleDataDetails', 'importSupplier', 'downloadImportSuppliersTemplate', 'searchSuppliers']);

export const productMethods = mapActions('products', ['getProduct', 'getProducts', 'searchProducts', 'createProduct', 'updateProduct', 'importProducts', 'exportProducts', 'downloadImportProductsTemplate', 'importProductsValidation', 'downloadErrorReport']);

export const supplierServiceMethods = mapActions('supplierServices', ['getService', 'getServices', 'createService', 'updateService', 'getAllServices', 'searchServices', 'searchAllServices']);
export const supplierManufacturedComponentsMethods = mapActions('supplierManufacturedComponents', ['getManufacturedComponent', 'getManufacturedComponents', 'createManufacturedComponent', 'updateManufacturedComponent', 'importManufacturedComponents', 'searchManufacturedComponents']);

export const supplierManufacturedItemsMethods = mapActions('supplierManufacturedItems', ['getManufacturedItem', 'getManufacturedItems', 'createManufacturedItem', 'updateManufacturedItem', 'importManufacturedItems', 'getAllManufacturedItems', 'searchManufacturedItems', 'searchAllManufacturedItems']);

export const stockMethods = mapActions('stocks', ['getStock', 'getStocks', 'updateStock', 'searchStocks', 'getStockReserved', 'exportStockList', 'getTransferStocks']);
export const stockManufacturedItemMethods = mapActions('stockManufacturedItems', ['getStockManufacturedItem', 'getStockManufacturedItems']);

export const warehouseMethods = mapActions('warehouses', ['getWarehouses', 'getWarehouse', 'createWarehouse', 'updateWarehouse', 'importWarehouses', 'exportWarehousesCsv', 'downloadImportWarehousesTemplate']);
export const warehouseComputed = {
  ...mapGetters('warehouses', ['listWarehouses']),
}

export const transferMethods = mapActions('transfers', ['getTransfer', 'getTransfers', 'updateTransfer', 'createTransfer', 'deleteTransfer', 'rejectTransfer', 'confirmReceived', 'downloadTransfer', 'updateTransferStatus']);
export const transferInboundMethods = mapActions('transferInbounds', ['getTransferInbounds', 'getTransferInbound', 'createTransferInbound', 'updateTransferInbound', 'deleteTransferInbound', 'confirmReceived', 'downloadInBound', 'updateTransferInboundStatus', 'sendTransferInbound', 'rejectTransferintbound', 'cancellTransferintbound', 'receiveTransferInbound', 'reorderTransferInbound']);
export const transferOutboundMethods = mapActions('transferOutbounds', ['getTransferOutbounds', 'getTransferOutbound', 'createTransferOutbound', 'updateTransferOutbound', 'sendTransferOutbound', 'receiveTransferOutbound', 'rejectTransferOutbound', 'confirmDelivered', 'downloadOutBound', 'deleteOutbound', 'updateTransferOutboundStatus', 'returnOutbound', 'reorderTransferOutbound']);
export const internalPurchaseOrderMethods = mapActions('internalPurchaseOrder', [
  'getInternalPurchaseOrders', 'getInternalPurchaseOrder', 'createInternalPurchaseOrder', 'updateInternalPurchaseOrder',
  'approveInternalPurchaseOrder', 'deleteInternalPurchaseOrder', 'cancelInternalPurchaseOrder',
  'updateItemsAdditional', 'rejectInternalPurchaseOrder', 'updateInternalPurchaseOrderStatus',
  'downloadInternalPurchaseOrder', 'xeroSyncInternalPurchaseOrder']);
export const productStockMethods = mapActions('productStocks', ['getProductStocks', 'searchProductStocks']);


export const historiesMethods = mapActions('documentHistories', ['getHistories']);
export const projectMethods = mapActions('projects', ['getProject', 'getProjects', 'createProject', 'updateProject']);
export const quoteMethods = mapActions('quotes', [
  'getQuote', 'getQuotes', 'createQuote', 'updateQuote', 'updateQuoteStatus',
  'acceptQuote', 'cloneQuote', 'downloadQuote', 'deleteQuote', 'declineQuote',
  'updateItemsAdditional']);
export const saleOrderMethods = mapActions('saleOrders', [
  'getSaleOrder', 'getSaleOrders', 'acceptOrder', 'updateSaleOrder', 'updateSaleOrderStatus',
  'revertOrder', 'deleteSaleOrder', 'declineSaleOrder', 'cancelSaleOrder', 'allocateOrder',
  'deallocateOrder', 'shipOrder', 'downloadSaleOrder','xeroSyncSaleOrder', 'updateItemsAdditional',
  'createVariation', 'acceptVariation', 'searchSaleOrders'
]);
export const invoiceMethods = mapActions('invoices', [
  'getInvoice', 'getInvoices', 'updateInvoice', 'updateInvoiceStatus', 'downloadInvoice', 'returnInvoice',
  'xeroSyncInvoice', 'updateItemsAdditional', 'deleteInvoice', 'cancelInvoice'
]);
export const statusGetters = mapGetters('statuses', ['getAdminStatuses']);
export const statusMethods = mapActions('statuses', ['getStatuses']);
export const purchaseOrderMethods = mapActions('purchaseOrders', [
  'getPurchaseOrder', 'getPurchaseOrders', 'createPurchaseOrder', 'updatePurchaseOrder',
  'updatePurchaseOrderStatus', 'approvePurchaseOrder', 'deletePurchaseOrder', 'rejectPurchaseOrder',
  'updateItemsAdditional', 'cancelPurchaseOrder', 'downloadPurchaseOrder', 'xeroSyncPurchaseOrder']);

export const termMethods = mapActions('terms', ['getTerms', 'getTerm', 'createTerm', 'updateTerm', 'deleteTerm', 'resolveTermOrganisationTypes']);

export const xeroMethods = mapActions('xero', ['getConfiguration', 'connect', 'disconnect', 'getAccoutCodes', 'getAccountCodesDefaults', 'updateAccoutCodes', 'syncAccoutCodes'])

// Imports
export const importGetters = {
  ...mapGetters('imports', ['getMultipleFiles', 'getSingleFile', 'getMapping', 'getNextTab'])
}
export const importMethods = {
  ...mapActions('imports', ['setFiles', 'setFile', 'setMapping', 'setNextTab'])
}

// Supplier brands
export const brandsComputed = {
  ...mapGetters('brands', [ 'listBrands' ]),
}

// Document Collections
export const documentComputeds = {
  ...mapGetters('documents', [ 'getProjectDocumentCounts', 'getCustomerDocumentCounts' ]),
}
export const documentMethods = {
  ...mapActions('documents', [ 'updateProjectDocumentCounts', 'updateCustomerDocumentCounts', 'resolveDocuments', 'resolveDocumentFilters', 'searchDocuments']),
}
// Dashboards
export const dashboardMethods = {
  ...mapActions('dashboards', [ 'resolveDashboardUser', 'resolveDashboardMine']),
}

// Returns
export const returnMethods = {
  ...mapActions('returns', [
    'resolveReturns', 'resolveReturn', 'createReturn', 'updateReturn',
    'resolveReturnableStocks', 'deleteReturn', 'changeReturnStatus', 'updateItemsAdditional' ]),
}
// Credit-Notes
export const creditNoteMethods = {
  ...mapActions('creditNotes', [ 'resolveCreditNotes', 'resolveCreditNote', 'createCreditNote', 'updateCreditNote', 'deleteCreditNote', 'changeCreditNoteStatus' ]),
}

export const brandMethods = mapActions('brands', [ 'getBrands', 'getListBrands', 'getBrand', 'getBrandRanges' ]);

// Supplier categories
export const categoriesComputed = {
  ...mapGetters('categories', [ 'listCategories' ]),
}

export const errorsComputed = {
  ...mapGetters('errors', [ 'getErrors' ]),
}

export const categoryMethods = mapActions('categories', [ 'getCategories', 'getListCategories' ]);

export const miscellaneousMethods = mapActions('miscellaneous', [ 'getMiscellaneous', 'convertToProduct' ]);

// Customer store
export const customersComputed = {
  ...mapGetters('customers', ['listCustomers', 'listTerms', 'detailCustomer']),
}

export const customersMethods = mapActions('customers', ['getCustomers', 'toggleDataDetails', 'exportCustomersCsv', 'createCustomerProject',
  'getTerms', 'createCustomer', 'getCustomer', 'updateCustomer', 'importCustomer', 'downloadImportCustomersTemplate', 'getListCustomers',
  'deleteCustomer', 'searchCustomers'])

// Sale Rep Type store
export const saleRepTypesComputed = {
  ...mapGetters('saleRepTypes', ['listSaleRepTypes']),
}

export const saleRepTypesMethods = mapActions('saleRepTypes', ['getSaleRepTypes', 'getListSaleRepTypes', 'pushSaleRepType'])

// Settings
export const settingsComputed = {
  ...mapGetters('settings', ['dateLocale']),
}
export const settingMethods = mapActions('settings', ['setDateLocale'])

// Projects valid / invalid statuses arrays
// Positive active states
export const quoteActiveKeys = ['sent']
export const salesActiveKeys = ['sent','accepted','resend']
export const purchasesActiveKeys = ['sent','accepted']
export const invoicesActiveKeys = ['sent','accepted']

// Positive End State
export const quoteCompletedKeys = ['accepted']
export const salesCompletedKeys = ['complete']
export const purchasesCompletedKeys = ['complete']
export const invoicesCompletedKeys = ['complete']

// Negative End States
export const quoteStaleKeys = ['cancelled','expired']
export const salesStaleKeys = ['cancelled','declined','reverted']
export const purchasesStaleKeys = ['cancelled','declined']
export const invoicesStaleKeys = ['cancelled','declined']

// Country store
export const windowsComputed = {
  ...mapGetters('window', [
    'width', 'height', 'orientation',
    'isMobile', 'isTablet', 'isLargeTablet',
    'isLandscape', 'isPortrait',
    'isIos', 'isRetina', 'retinaRatio',
  ]),
}
